import { render } from "./userNote.vue?vue&type=template&id=1d53e8e0&scoped=true"
import script from "./userNote.vue?vue&type=script&lang=js"
export * from "./userNote.vue?vue&type=script&lang=js"

import "./userNote.vue?vue&type=style&index=0&id=1d53e8e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d53e8e0"]])

export default __exports__